import styled from '@emotion/styled';
import { Autocomplete, css, TextField } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { colors } from 'theme/colors';

interface IStyledFormControl {
  error: boolean;
}
export const StyledTextField = styled(TextField)({
  fieldset: {
    borderRadius: 4,
  },
  input: {
    fontSize: 14,
    height: 32,
    backgroundColor: `${colors.white}`,
    boxSizing: 'border-box',
  },
  textarea: {
    fontSize: 14,
  },
  'input::placeholder, textarea::placeholder': {
    fontSize: 14,
    fontWeight: 400,
    color: `${colors.gray400}`,
    fontFamily: 'NotoSansRegular, sans-serif',
    opacity: 1,
  },
  '& .MuiOutlinedInput-root': {
    height: 32,
    marginBottom: 3,
    backgroundColor: colors.white,

    ' & fieldset ': {
      borderColor: colors.gray400,
      borderWidth: '1px',
    },

    '&:hover:not(.Mui-focused, .Mui-disabled) fieldset ': {
      borderColor: colors.primary400,
    },

    '&.Mui-focused fieldset ': {
      borderColor: colors.primary400,
      borderWidth: '2px',
    },

    '&:active fieldset ': {
      borderColor: colors.primary900,
      borderWidth: '1px',
    },

    '&.Mui-error fieldset ': {
      borderColor: colors.error800,
      borderWidth: '1px',
    },

    '& .MuiInputAdornment-root .MuiIconButton-root ': {
      color: colors.gray900,
    },

    '&.Mui-disabled .MuiInputAdornment-root .MuiIconButton-root ': {
      color: colors.gray400,
    },
  },
  '& .MuiAutocomplete-input': {
    marginBottom: 4,
    marginTop: '-9px',
    marginLeft: '-10px',
    marginRight: '-10px',
    paddingLeft: '10px !important',
  },
  '& .MuiAutocomplete-endAdornment': {
    right: '4px !important',
    bottom: '-15px !important',
  },
});

export const StyledFormControl = styled(FormControl) <IStyledFormControl>`
  width: 100%;
  margin: 0;
  & .MuiOutlinedInput-root {
    & .MuiAutocomplete-input {
      padding: 5px 4px 5px 5px;
      margin-top: 0;
      margin-bottom: 0;
    }

    & fieldset {
      border-color: ${colors.gray400};
      border-width: 1px;
    }

    &:hover:not(.Mui-focused, .Mui-disabled) fieldset {
      border-color: ${colors.primary400};
    }

    &.Mui-focused fieldset {
      border-color: ${colors.primary400};
      border-width: 2px;
    }

    &:active fieldset {
      border-color: ${colors.primary900};
      border-width: 1px;
    }
  }

  ${(props: IStyledFormControl) =>
    props.error &&
    css`
      & .MuiOutlinedInput-root fieldset {
        border-color: ${colors.error800};
        border-width: 1px;
      }

      &:hover .MuiOutlinedInput-root fieldset {
        border-color: ${colors.error800};
      }
    `}
`;

interface IStyledAutocomplete {
  disabled?: boolean;
}
export const StyledAutocomplete = styled(Autocomplete) <IStyledAutocomplete>`
  ${(props: IStyledAutocomplete) =>
    props.disabled &&
    css`
      background: ${colors.gray100} !important;
      input {
        color: ${colors.gray400};
        background: ${colors.gray100} !important;
      }
    `}
`;

export const StyledInnerWrapper = styled.div`
  font-size: 14px;
  margin-bottom: 3px;
  height: 32px;
`;
